module.exports = __webpack_public_path__ + "static/media/man-left.bb9fccc2.png";